import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ProfileList from "@/modules/profile/admin/components/ProfileList";

export const Route = createFileRoute("/admin/_panel/_profile/profile/requests")(
  {
    component: RouteComponent,
    beforeLoad: ({ context }) => {
      throwIfHasNoPermission(context.user, "profile.profile-request.view");

      return {
        crumb: [
          {
            label: context.t("Inbox", { ns: "core.shared" }),
          },
        ],
      } satisfies ChildRouteContext;
    },
  },
);

function RouteComponent() {
  const { t } = useTranslation("profile.admin");
  return (
    <Container
      title={t("Inbox", { ns: "core.shared" })}
      description={t("Manage profile change requests")}
    >
      <ProfileList />
    </Container>
  );
}
